exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-selectbatch{\n    height: 40px;\n}\n\n:host >>> .tooltip .tooltip-inner {\n    max-width: 600px;\n    min-width: 600px;\n    white-space: normal;\n    text-align: left\n  }\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/batchstamp/import-stamp/import-stamp.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/batchstamp/import-stamp/import-stamp.component.css
// module chunks = 3